let websocket = (onMessage, onOpen, onClose) => {
	let socket;

	let MessagesToSend = [];

	let url = "wss://smart.hilgard.cz/web";
	if (new URL(window.location).origin.indexOf("192.168") >0 || new URL(window.location).origin.indexOf("localhost") >0 ) {
		url= "ws://192.168.10.155:8080/web";
	}

	console.log("URL: ", url);

	let lastMessage = new Date().getTime();

	let _connect = () => {
		console.log("Connectiong to websocket...");
		socket = new WebSocket(url);

		socket.onopen = () => {
			if (onOpen) {
				onOpen(); // call callBack on open for login atd...
			}
			console.log("Opening web socket...", socket);
		};

		socket.onclose = () => {
			socket = null;
			if (onClose) {
				onClose();
			}
			setTimeout(_connect, 500);
		};

		socket.onmessage = (message) => {
			lastMessage = new Date().getTime();
			if (message.data == "ping") {
				// console.log("Sending pong...");
				sendMessage("pong");
			} else {
				onMessage(message.data);
			}

			if (!["ping", "pong"].includes(message.data)) {
				console.log(
					new Date().toLocaleString("cs-CS"),
					"On message =>",
					message.data
				);
			}
		};
	};

	_connect(); // call connect

	setInterval(() => {
		if (lastMessage + 20 * 1000 < new Date().getTime()) {
			console.log("Reconnecting to socket");
			lastMessage = new Date().getTime();
			if (socket) {
				// not NULL while reconnection...
				socket.close();
			}
		} else if (lastMessage + 10 * 1000 < new Date().getTime()) {
			if (socket) {
				// not NULL while reconnection...
				sendMessage("ping");
			}
		}
	}, 5000);

	// Kdyz nebude socket ready, odesleme zpravy jakmile obnovime spojeni...
	setInterval(() => {
		if (MessagesToSend.length) {
			_processSendMessage();
		}
	}, 1000);

	let _processSendMessage = (msg) => {
		if (msg) {
			MessagesToSend.push(msg);
		}

		if (socket != null) {
			if (socket.readyState == 1) {
				while (MessagesToSend.length) {
					let ms = MessagesToSend.shift(); // prvni zpravu v queue...
					socket.send(ms);
					if (!["ping", "pong"].includes(msg)) {
						console.log("Sending message:", ms);
					}
				}
			}
		}
	};

	let sendMessage = (msg) => {
		if (typeof msg == "string") {
			if (!["ping", "pong"].includes(msg)) {
				console.log("Queing message: ", msg);
			}
			_processSendMessage(msg);
		} else if (typeof msg == "object") {
			if (!["ping", "pong"].includes(msg)) {
				console.log("Queing message: ", msg);
			}
			_processSendMessage(JSON.stringify(msg));
		} else {
			console.log("!!!Neznámý typ msg", typeof msg);
		}
	};

	return {
		sendMessage,
	};
};
// let socket = websocket(function(msg) {
// 	console.log("Icome message: ", msg);
// });

export default { websocket };
